import { Outlet } from "react-router-dom";
import { useState, useEffect } from 'react';
import useRefreshToken from '../../hooks/useRefreshToken';
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth } = useAuth();
    useAxiosPrivate();

    useEffect(() => {
        const verifyRefreshToken = async () => {
            try {
                await refresh();
            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        }
        !auth?.user?.accessToken ? verifyRefreshToken() : setIsLoading(false);
    }, []);
    
    return (
        <>
            {isLoading 
                ? <p>Loading...</p>
                : <Outlet />
            }
        </>
    )
}

export default PersistLogin